import React from "react";
import { Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Button } from "../../ui/button";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const RentFurnitureModal: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Info className="h-4 w-4 text-blue-500" />
            Importante: Inventario de Muebles
          </DialogTitle>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <p className="text-sm text-gray-700">
            Al momento de firmar tu contrato de arrendamiento, es{" "}
            <strong>indispensable</strong> que lleves tu inventario de muebles y
            estado del inmueble <strong>impreso y a color</strong> para que sea
            anexado al contrato.
          </p>
          <p className="text-sm text-gray-500">
            Este documento forma parte integral del contrato y debe incluir el
            detalle completo de los muebles que se incluyen en la renta.
          </p>
        </div>
        <DialogFooter>
          <Button onClick={onClose} className="w-full sm:w-auto">
            Entendido
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
